import React from 'react';
import classNames from 'classnames';

const Asset = ({ asset, className, selectedAsset, hoveredAsset, onSelectAsset, onHoverAsset }) => (
  <a
    className={classNames(
      'asset',
      {
        'text-muted': asset.decommissioned,
        'selected': asset == selectedAsset,
        'vdc-hovered': asset === hoveredAsset
      },
      powerClassname(asset.metadata['power_state']),
      maintenanceClassname(asset.metadata['maintenance_state']),
      className
    )}
    onMouseEnter={() => onHoverAsset(asset)}
    onMouseLeave={() => onHoverAsset(null)}
    onClick={() => onSelectAsset(asset)}
  >
    <div className="asset-content">
      <span className={`fa fa-fw ${asset.decommissioned ? 'fa-ban' : asset.icon || 'fa-cube'} ml-1 mr-2`}></span>
      <span className="asset-name">{ asset.name }</span>
      <span className="metadata-icons"></span>
    </div>
  </a>
);

function powerClassname(power_state){
  if (power_state === undefined) {
    return '';
  }
  const prefix = 'powered-';
  return prefix + power_state;
};

function maintenanceClassname(maintenance_state){
  if (maintenance_state === undefined) {
    return '';
  }
  return maintenance_state;
};

export default Asset;
